// extracted by mini-css-extract-plugin
export default {"footer-container":"Footer_footer-container__Ocrdn","footer-links":"Footer_footer-links__0pj9X","left-links":"Footer_left-links__Dyj-N","right-link":"Footer_right-link__FkQsR"};